class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const mobilecount = new DOMParser().parseFromString(html, 'text/html').querySelector('.mobile-facets__footer button').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    const containerMobile = document.querySelector('.mobile-facets__footer button');
    const containerMobileSort = document.querySelector('#FacetSortFormMobile .mobile-facets__footer button');
    containerMobile.innerHTML = mobilecount;
    containerMobileSort.innerHTML = mobilecount;
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
      // document.querySelector(selector).classList.toggle('loaded');
    }) 

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting', '.mobile-facets__openers .opener-filter'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile' || event.target.closest('form').id === 'FacetSortFormMobile';
      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile' || form.id === 'FacetSortFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input[type="number"]')
      .forEach(element => element.addEventListener('input', this.onRangeChange.bind(this)));
    this.progress = this.querySelector(".range-slider .progress");
    this.rangeInput = this.querySelectorAll('input[type="range"]');
    this.priceInput = this.querySelectorAll('input[type="number"]');
    this.priceGap = 5;
    this.querySelectorAll('input[type="range"]')
      .forEach(element => element.addEventListener('input', this.onSlideRangeChange.bind(this)));
    
    // this.setMinAndMaxValues();
  }

  onRangeChange(e) {
    // this.adjustToValidValues(event.currentTarget);
    // this.syncValues(event.currentTarget)
    let inputs = this.querySelectorAll('input[type="number"]');
    let max = parseFloat(e.target.getAttribute('max'));
    let valeur = parseFloat(e.target.value);
    
    if (valeur > max) {
      e.target.value = max;
    }
    inputs.forEach(inp => {
      let theVal = parseFloat(inp.value);
      if(!theVal){
        inp.value = parseFloat(inp.getAttribute('min'));
      }
    })
    let minPrice = parseInt(this.priceInput[0].value),
      maxPrice = parseInt(this.priceInput[1].value);
      
    if (maxPrice - minPrice < this.priceGap ) {
      if (e.target.classList.contains('input-min')) {
        this.priceInput[0].value = maxPrice - this.priceGap;
      } else {
        this.priceInput[1].value = minPrice + this.priceGap;
      }
      // if (e.target.className === "input-min") {
      //   this.rangeInput[0].value = minPrice;
      //   this.progress.style.left = (minPrice / this.rangeInput[0].max) * 100 + "%";
      // } else {
      //   this.rangeInput[1].value = maxPrice;
      //   this.progress.style.right = 100 - (maxPrice / this.rangeInput[1].max) * 100 + "%";
      // }
    }else{
      this.rangeInput[0].value = minPrice;
      this.rangeInput[1].value = maxPrice;
      this.progress.style.left = (minPrice / this.rangeInput[0].max) * 100 + "%";
      this.progress.style.right = 100 - (maxPrice / this.rangeInput[1].max) * 100 + "%";
    }
  }
  onSlideRangeChange(e){
    let minVal = parseInt(this.rangeInput[0].value),
      maxVal = parseInt(this.rangeInput[1].value);
    let valContainer = this.querySelector(`[rg="${e.target.dataset.val}"]`);
    if(valContainer) valContainer.innerHTML = e.target.value
    if (maxVal - minVal < this.priceGap) {
      if (e.target.className === "range-min") {
        this.rangeInput[0].value = maxVal - this.priceGap;
      } else {
        this.rangeInput[1].value = minVal + this.priceGap;
      }
    } else {
      this.priceInput[0].value = minVal;
      this.priceInput[1].value = maxVal;
      this.progress.style.left = (minVal / this.rangeInput[0].max) * 100 + "%";
      this.progress.style.right = 100 - (maxVal / this.rangeInput[1].max) * 100 + "%";
    }
  }

  setMinAndMaxValues(input) {
    const inputs = this.querySelectorAll('input[type="number"]');
    const rangeInputs = this.querySelectorAll('input[type="range"]');
    let minInput = inputs[0];
    let maxInput = inputs[1];
    if(input?.type == 'range'){
      minInput = rangeInputs[0];
      maxInput = rangeInputs[1];
    }
    if (maxInput.value){
      inputs[0].setAttribute('max', maxInput.value);
      rangeInputs[0].setAttribute('max', maxInput.value);
    } 
    if (minInput.value){
      inputs[1].setAttribute('min', minInput.value);
      rangeInputs[1].setAttribute('min', minInput.value);
    } 

    if (minInput.value === ''){
      inputs[0].setAttribute('min', 0);
      rangeInputs[0].setAttribute('min', 0);
    } 
    if (maxInput.value === ''){
      inputs[1].setAttribute('max', maxInput.getAttribute('max'));
      rangeInputs[1].setAttribute('max', maxInput.getAttribute('max'));
    } 
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
  
  syncValues(input){
    const inputs = this.querySelectorAll('input[type="number"]');
    const rangeInputs = this.querySelectorAll('input[type="range"]');
    let min = parseFloat(inputs[0].value);
    let max = parseFloat(inputs[1].value);
    if(input.type == 'range'){
      min = parseFloat(rangeInputs[0].value);
      max = parseFloat(rangeInputs[1].value);
    }
    
    if(inputs[0].value != rangeInputs[0].value){
      inputs[0].value = rangeInputs[0].value = min
    }
    if(inputs[1].value != rangeInputs[1].value){
      inputs[1].value = rangeInputs[1].value = max
    }
    
    this.progress.style.left = (min / rangeInputs[0].max) * 100 + "%";
    this.progress.style.right = 100 - (max / rangeInputs[1].max * 100) + "%";
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
